// extracted by mini-css-extract-plugin
export default {"heroimg":"HImage2_heroimg__-Doee","gridOverlay":"HImage2_gridOverlay__346i7","heading":"HImage2_heading__AXR3y"};